export default __webpack_public_path__ + "static/media/noun_web_3847454.3e2f8e3d.svg";